<template>
<div class="row h-100">
    <div class="col-md-10 mx-auto d-flex flex-column justify-content-between justify-content-md-center align-items-center h-100">

        <div class="d-flex justify-content-center align-items-center w-100 position-md-absolute top-0">
            <h4 class="border-bottom text-uppercase w-md-100 text-white mb-0 pb-2 pb-md-5">{{ panelHeading }}</h4>
        </div>

        <template v-for="(config, index) in steps">
            <component v-if="config.component && step == index"
                v-on:input="(val) => updateValue(config, val)"
                v-on:back="navigate(index - 1, config)"
                v-on:forward="navigate(index + 1, config)"
                :timestamp="timestamp"
                :value="formData[config.id]"
                :formSummary="formSummary"
                :config="config"
                :filters="filters"
                :type="type"
                :step="step"
                :error="formError"
                :key="config.id"
                :is="config.component"
                :harvestRange="regionHarvestRange"
                >
            </component>
        </template>

    </div>
</div>

</template>
<script>
import { ArrowLeftIcon, ArrowRightIcon } from 'vue-feather-icons';
import StartComponent from './hybrid-selector/StartComponent';
import UsageComponent from './hybrid-selector/UsageComponent';
import RegionComponent from './hybrid-selector/RegionComponent';
import MaturityComponent from './hybrid-selector/MaturityComponent';
import UtilsMixin from './UtilsMixin.js';

export default {
    data() {
        return {
            // use timestamp to reset checkout component's state
            formData: {
                start: '',
                type: '',
                region: '',
                maturity: {},
            },
            formSummary: {
                start: null,
                type: null,
                region: null,
                maturity: {},
            },
            formError: 0,
            query: {},
            hasStarted: false,
            hasSearched: false,
            showResults: false,
            // productCount: 0,
            timestamp: Date.now(),
            step: 0,
            steps: [
                {
                    id: 'start',
                    name: 'Get Started',
                    heading: 'Get Started',
                    component: StartComponent,
                    default: true,
                },
                {
                    id: 'type',
                    name: 'Select your usage',
                    heading: 'Select your usage',
                    component: UsageComponent,
                    // default: true,
                },
                {
                    id: 'region',
                    name: 'Select your region',
                    heading: 'Select your region',
                    component: RegionComponent,
                },
                {
                    id: 'maturity',
                    name: 'Maturity',
                    heading: 'Maturity',
                    component: MaturityComponent,
                    filters: this.config.filters,
                },
            ],
        }
    },

    props: ['initialData', 'config'],

    mixins: [
        UtilsMixin,
    ],

    components: {
        ArrowLeftIcon,
        ArrowRightIcon,
        // ProductGridComponent,
    },

    watch: {
        step(newVal) {
            if(newVal > 0){
                this.hasStarted = true;
            }
        }
    },

    computed: {
        currentStepHasInput() {
            let stepField = _.get(this.steps, [this.step, 'id']);
            return !!_.get(this.formData, stepField);
        },
        hybridsPath() {

            let obj = _.get(this.config.filters, this.type, {});
            return obj.path || null;

        },
        panelHeading() {
            return _.get(this.initialData, 'panel.label') || _.get(this.initialData, 'panel.name');
        },
        type() {
            return _.get(this.formData, 'type');
        },
        filters() {
            return _.get(this.config, 'filters');
        },
        regionHarvestRange() {
            if(this.type == 'silage' && parseInt(this.formData.region) > 0){

                let hybrids = _.chain(this.hybridMapping)
                    .filter((obj) => {
                        return obj.hybrid_region_id == this.formData.region;
                    })
                    .map((region) => {
                        return _.pick(region, ['harvestday_start', 'harvestday_end'])
                    })
                    .value();

                let min = _.minBy(hybrids, 'harvestday_start');
                let max = _.maxBy(hybrids, 'harvestday_end');

                return {
                    'min': min.harvestday_start,
                    'max': max.harvestday_end,
                }
            }

            return {};
        }
    },

    methods: {
        updateValue(config, val) {
            // console.log(config,val);
            let key = config.id;
            this.formData[key] = _.get(val, 'id', val);
            this.formSummary[key] = val;
            this.showResults = false;

            if(!this.hasSearched){
                if(this.step < 3){
                    this.step += 1;
                }else{

                    this.setReferrer();

                    // redirect to hybrids page with querystring parameters
                    this.search();
                }
            }
        },

        updateTarget(val){

            this.steps[1].heading = val == 'their' ? _.replace(this.steps[1].heading, 'your', 'their') : _.replace(this.steps[1].heading, 'their', 'your');

        },

        navigate(step) {
            if (step > this.step) {
                return;
            }

            this.step = step;
        },

        forward() {
            this.step += 1;
        },

        back() {
            this.step -= 1;
        },

        setStep(step) {
            this.showResults = false;
            this.step = step;
        },

        search() {

            let params = [
                this.formData.region ? `region_id=${this.formData.region}` : false,
                this.formData.maturity.crm ? `maturity=${_.join(this.formData.maturity.crm, ',')}` : false,
                this.formData.maturity.harvestDate ? `harvestDate=${this.formData.maturity.harvestDate}` : false,
                this.formData.maturity.plantDate ? `plantDate=${this.formData.maturity.plantDate}` : false,
            ];

            let queryString = _.chain(params).filter().join('&').value();

            // console.log(this.formData.maturity);
            // console.log(queryString);

            // redirect to hybrid results
            window.location.href = `/${this.hybridsPath}?${queryString}`;

            // this.hasSearched = true;
        },

        setReferrer() {
            window.localStorage.setItem('hybridsReferrer', 'hybridSelector');
        }

    },
}
</script>